import flowRight from 'lodash/flowRight'
import { makeSelectCurOrg } from 'logic/orgs'
import Link from 'next/link'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedDate } from 'react-intl'
import { createStructuredSelector } from 'reselect'
import { TicketteerLogo } from './index'
import { defaultDateFormat } from '../lib/misc'

const CompanyLogo = ({ org }) => (
  <Link href={`/${org.odn}`}>
    <div className="menu-company-logo cursor-pointer" style={{ backgroundImage: `url(${org.logo.full})` }} />
  </Link>
)

class Menu extends Component {
  
  render () {
    const { date, org, whiteLogo } = this.props
    return (
      <div className={process.env.HZL_INST ? '' : 'white-bg'}>
        <div>
          <div className="tt-nav-wrap pl-4">
            <TicketteerLogo whiteLogo={whiteLogo} />
            {date
              ? <div className="event-info">
                  <div className="event-title">
                      <Link href={`/${org.odn}/e/${date.event_id}`}>
                        <a href={`/${org.odn}/e/${date.event_id}`}>
                          {date.title}
                        </a>
                      </Link>
                    </div>
                  <div className="date-time">
                    <FormattedDate value={date.starts_at} {...defaultDateFormat} /><span className="ml-1 mr-1">|</span>{date.location.name}
                  </div>
                </div>
              : <a href="https://www.ticketteer.com" className="tt-name">
                  ticketteer
                </a>
            }
            <div className="org-header">
              <Link href={`/${org.odn}`}>
                <a href={`/${org.odn}`} className="org-name">
                  {org.logo.thumb
                    ? <CompanyLogo org={org} />
                    : org.name
                  }
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  org: makeSelectCurOrg(),
});

const enhance = flowRight(
  connect(mapStateToProps),
)

export default enhance(Menu)
